export const GetClients = `query {
  getClients {
    therapistId
    totalCharges
    insuranceBalance
    totalPaid
    id
    username
    status
    active
    gender
    dateOfBirth
    address {
      city
      line1
      line2
      state
      zip
    }
    contact {
      phone
      type
      email
    }
    personalDetail {
      first
      middle
      last
      suffix
      nickname
    }
  }
}`;

export const AddClient = `mutation addClient($input: ClientInput!) {
  addClient(input: $input) {
    therapistId
    id
    status
    active
    gender
    sendEmailReminder
    dateOfBirth
    address {
      city
      line1
      line2
      state
      zip
    }
    contact {
      phone
      type
      email
    }
    personalDetail {
      first
      middle
      last
      suffix
      nickname
    }
    communicationSetting{
    email
    }
  }
}`;

export const getAppsUsed = `query {
  getAppsUsed {
    apps {
      ACT
      DBT
      IFS
      CBT
      COACH
      MI
    }
    defaultApp
  }
}`;
export const getAppsUsedByTeamOwner = `query getAppsUsedByTeamOwner($teamOwnerId: String!){
  getAppsUsedByTeamOwner(teamOwnerId: $teamOwnerId) {
    apps {
      ACT
      DBT
      IFS
      CBT
      COACH
      MI
    }
    defaultApp
  }
}`;
export const getHideCommunitiesForApps = `query getHideCommunitiesForApps($teamOwnerId: String!){
  getHideCommunitiesForApps(teamOwnerId: $teamOwnerId) {
    hideCommunities {
      ACT
      DBT
      IFS
      CBT
      COACH
      MI
    }
  }
}`;

export const getHideHealthNutritionForApps = `query getHideHealthNutritionForApps($teamOwnerId: String!){
  getHideHealthNutritionForApps(teamOwnerId: $teamOwnerId) {
    food {
      ACT
      DBT
      IFS
      CBT
      COACH
      MI
    }
    physical_activity {
      ACT
      DBT
      IFS
      CBT
      COACH
      MI
    }
  }
}`;

export const hasEnterpriseSub = `query {
  hasEnterpriseSubscription {
    hasEnterpriseSubscription
  }
}`;

export const UpdateClient = `mutation editClient($id: String!, $input: ClientInput!) {
  editClient(id: $id, input: $input) {
    therapistId
    id
    status
    active
    gender
    sendEmailReminder
    dateOfBirth
    address {
      city
      line1
      line2
      state
      zip
    }
    contact {
      phone
      type
      email
    }
    personalDetail {
      first
      middle
      last
      suffix
      nickname
    }
    communicationSetting{
    email
    }
  }
}`;

export const RemoveClient = `mutation removeClient($id: String!) {
  removeClient(id: $id) {
    message
    status
  }
}`;
